/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'video': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M30 10.953v10.094c0 .392-.205.757-.544.966-.338.21-.763.234-1.124.066L23 19.592v.98c0 .909-.369 1.78-1.025 2.424A3.538 3.538 0 0119.5 24h-14a3.538 3.538 0 01-2.475-1.004A3.394 3.394 0 012 20.57V11.43c0-.91.369-1.782 1.025-2.425A3.538 3.538 0 015.5 8h14c.928 0 1.819.361 2.475 1.004A3.394 3.394 0 0123 11.43v.979l5.332-2.487a1.188 1.188 0 011.124.066c.339.21.544.574.544.966z" _fill="#0B2C62"/>'
  }
})
